/**
 * @generated SignedSource<<f8b33e900dd8bcd51dbeba57d6acb3ed>>
 * @relayHash 26bc0b6719e6e25b9a11ef2be03dcb10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID abfeafef1f1daca3970cf1613281d8d84dc1b0109f2b49a55d8d7974e0000a07

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioAgentQueryInput = {
  includeDraftAgents?: boolean | null;
  includeJiraCodingAgent?: boolean | null;
  name?: string | null;
  onlyEditableAgents?: boolean | null;
  onlyFavouriteAgents?: boolean | null;
  onlyMyAgents?: boolean | null;
  onlyPublishedEditableAgents?: boolean | null;
  onlyPublishedEditableAgentsWithForge?: boolean | null;
  onlyTemplateAgents?: boolean | null;
  onlyUnpublishedAgents?: boolean | null;
  onlyVerifiedAgents?: boolean | null;
};
export type agentCategorySectionQuery$variables = {
  cloudId: string;
  cloudIdString: string;
  enableJiraAgentFields?: boolean | null;
  first?: number | null;
  input?: AgentStudioAgentQueryInput | null;
  product?: string | null;
  skipUserPermissions?: boolean | null;
  workspaceId?: string | null;
};
export type agentCategorySectionQuery$data = {
  readonly atlassianStudio_userSiteContext?: {
    readonly userPermissions?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef">;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent">;
};
export type agentCategorySectionQuery = {
  response: agentCategorySectionQuery$data;
  variables: agentCategorySectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "enableJiraAgentFields"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v6 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipUserPermissions"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdString"
},
v9 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v10 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v11 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v12 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v13 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v14 = [
  (v8/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "agentCategorySectionQuery",
    "selections": [
      {
        "args": [
          (v8/*: any*/),
          {
            "kind": "Variable",
            "name": "cloudIdAsId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "enableJiraAgentFields",
            "variableName": "enableJiraAgentFields"
          },
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "agentCategorySection_AtlassianConversationAssistantAgent_AgentCategorySectionContent"
      },
      {
        "condition": "skipUserPermissions",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "FragmentSpread",
                        "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_userPermissionsRef"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "agentCategorySectionQuery",
    "selections": [
      {
        "args": (v14/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "deactivated"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creatorType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v15/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "icon"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  {
                    "condition": "enableJiraAgentFields",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "AgentStudioAgentPermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canEdit"
                          }
                        ]
                      },
                      {
                        "args": (v13/*: any*/),
                        "concreteType": "JiraAgentAssignability",
                        "kind": "LinkedField",
                        "name": "jiraAssignability",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isAssignable"
                          }
                        ]
                      }
                    ]
                  },
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v14/*: any*/),
        "filters": [
          "cloudId",
          "input",
          "product",
          "workspaceId"
        ],
        "handle": "connection",
        "key": "paginatedAgentsList_agentStudio_getAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      },
      {
        "condition": "skipUserPermissions",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v13/*: any*/),
            "kind": "LinkedField",
            "name": "atlassianStudio_userSiteContext",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "AtlassianStudioUserProductPermissions",
                    "kind": "LinkedField",
                    "name": "userPermissions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "isAbleToGovernAgents"
                      }
                    ]
                  }
                ],
                "type": "AtlassianStudioUserSiteContextOutput"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "abfeafef1f1daca3970cf1613281d8d84dc1b0109f2b49a55d8d7974e0000a07",
    "metadata": {},
    "name": "agentCategorySectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "852b1f2a5fef9fe96d9c5a48a26f520a";

export default node;
